import { apiFetch } from './api';

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

/** この端末でプッシュ通知が使えるか（SW/PushManager対応かつ非iOS制約でない） */
export function pushSupported(): boolean {
  return typeof navigator !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

/** 現在この端末が購読済みか */
export async function isPushEnabled(): Promise<boolean> {
  if (!pushSupported()) return false;
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    const sub = await reg?.pushManager.getSubscription();
    return !!sub && Notification.permission === 'granted';
  } catch { return false; }
}

/** 通知を有効化（許可要求→購読→サーバー登録）。戻り値でUI表示。 */
export async function enablePush(): Promise<{ ok: boolean; reason?: string }> {
  if (!pushSupported()) return { ok: false, reason: 'この端末は通知に対応していません' };
  try {
    const perm = await Notification.requestPermission();
    if (perm !== 'granted') return { ok: false, reason: '通知が許可されませんでした（端末の設定から許可してください）' };
    const reg = await navigator.serviceWorker.ready;
    const res = await apiFetch<{ data: { key: string; enabled: boolean } }>('/push/vapid-public-key');
    if (!res.data?.enabled || !res.data.key) return { ok: false, reason: 'サーバー側で通知が無効です' };
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(res.data.key) });
    }
    const json = sub.toJSON();
    await apiFetch('/push/subscribe', { method: 'POST', body: JSON.stringify({ endpoint: sub.endpoint, keys: json.keys }) });
    return { ok: true };
  } catch (e) {
    return { ok: false, reason: e instanceof Error ? e.message : '通知の有効化に失敗しました' };
  }
}

/** 通知を無効化（購読解除＋サーバー削除） */
export async function disablePush(): Promise<void> {
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    const sub = await reg?.pushManager.getSubscription();
    if (sub) {
      await apiFetch('/push/unsubscribe', { method: 'POST', body: JSON.stringify({ endpoint: sub.endpoint }) }).catch(() => {});
      await sub.unsubscribe().catch(() => {});
    }
  } catch { /* noop */ }
}
